module.exports = __webpack_public_path__ + "img/cooperate_qy_09@2x.3a22ecb0.png";